<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            linkvideoajuda="https://www.youtube.com/embed/q8-WCjIwPeU"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="equipes"
              label="no_equipe"
              placeholder="Último atendimento"
              @input="onChangeEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_equipe }}
                {{ option.nu_ine != 'todos' ? '- ' + option.nu_ine : '' }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="Cidadãos-sem-equipe"
              >
              </download-files>
            </div>
          </div>
          <v-app class="app-tabela">
            <div class="box" style="margin-top: 0px">
              <v-card class="tabela">
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Nome do cidadão(a)"
                    class="input-bottom"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  @pagination="getPagination"
                  :page="currentPage"
                  :footer-props="{
                    itemsPerPageText: '',
                    'items-per-page-options': [10],
                    'disable-items-per-page': true,
                  }"
                  :loading="loading"
                  loading-text="Carregando, Por favor espere"
                  :headers="headers"
                  :items="displayedCadastros"
                  :search="search"
                  :single-expand="true"
                  :expanded.sync="expanded"
                  item-key="id"
                  show-expand
                  class="elevation-1"
                >
                  <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
                  <template v-slot:[`footer.page-text`]="items">
                    <div class="info-table-item tabela-esus-pec">
                      <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
                    </div>
                    <span class="paginacao"
                      >{{ items.pageStart }} - {{ items.pageStop }} de
                      {{ items.itemsLength }} pessoas</span
                    >
                  </template>

                  <template v-slot:item.dt_nascimento="{ item }">
                    {{ formatDate(item.dt_nascimento) }}
                  </template>

                  <template v-slot:item.ult_atend="{ item }">
                    {{ formatDate(item.ult_atend) }}
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td colspan="6">
                      <table
                        class="table table-interna table-interna-comorbidades"
                      >
                        <thead>
                          <tr>
                            <th>CPF</th>
                            <th>CNS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div class="d-block mb-2">
                                <show-hide-field
                                  :value="item.nu_cpf"
                                ></show-hide-field>
                              </div>
                            </td>
                            <td>
                              <div class="d-block mb-2">
                                <show-hide-field
                                  :value="item.nu_cns"
                                ></show-hide-field>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </template>

                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      :height="10"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:no-data>
                    <div class="alert alert-info mb-0">
                      <b
                        >Nenhuma informação encontrada. Selecione outro
                        filtro.</b
                      >
                    </div>
                  </template>
                  <template v-slot:no-results style="padding: 0px">
                    <div class="alert alert-info mb-0">
                      <b
                        >Nenhuma informação encontrada. Selecione outro
                        filtro.</b
                      >
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-app>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'
import { mapState } from 'vuex'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import * as Functions from './functions.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'CidadaosDesvinculados',
  metaInfo: {
    title: 'eSUS Feedback - Cidadãos sem Equipe',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ShowHideField,
    DownloadFiles,
  },

  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'ÚLTIMO ATENDIMENTO',
          align: 'start',
          filterable: false,
          value: 'ult_atend',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        { text: '', value: 'data-table-expand' },
      ],
      equipe: '',
      equipeNome: '',
      cadastrosOriginais: [],
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  mixins: [utils],
  watch: {
    search: {
      handler(newValue) {
        if (newValue) {
          this.filterSearch({ filter: this.filterItems(newValue) })
          return
        }
        this.filterSearch({ filter: false })
      },
      deep: true,
    },
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
        }
      })
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },

    async onChangeEquipe(event) {
      this.search = ''
      this.loading = true
      if (event !== null) {
        this.equipeNome = event.no_equipe
        this.equipe = event
        this.cadastros = this.cadastrosOriginais.filter((item) => {
          return item.ine_atend == this.equipe.nu_ine
        })
      } else {
        this.cadastros = this.cadastrosOriginais
        this.equipeNome = ''
        this.equipe = ''
      }
      this.loading = false
    },

    buscarCidadaosDesvinculados() {
      this.loading = true
      this.$api
        .get('/app/cidadaos-desvinculados/' + this.cod_ibge)
        .then((response) => {
          this.cadastrosOriginais = response.data
          this.cadastros = response.data
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
          this.loading = false
        })
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe)
    },
    validateToken() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarCidadaosDesvinculados()
    },
  },
  created() {
    this.validateToken()
  },
}
</script>

<style></style>
